import { gql } from "@apollo/client";

const UPDATE_BANNER = gql`
  mutation updateBanner(
    $id: Int!
    $platform: Int!
    $headLine: String!
    $subHeadLine: String!
    $buttonText: String!
    $buttonLink: String!
    $primaryColor: String!
    $status: String!
    $role: String
    $sports: [Int!]
    $images: [Upload!]
    $imageURLs: [String!]
  ) {
    updateBanner(
      updateBannerInput: {
        id: $id
        platform: $platform
        headLine: $headLine
        subHeadLine: $subHeadLine
        buttonText: $buttonText
        buttonLink: $buttonLink
        primaryColor: $primaryColor
        status: $status
        role: $role
        sports: $sports
        images: $images
        imageURLs: $imageURLs
      }
    ) {
      id
    }
  }
`;

export default UPDATE_BANNER;
